// Profile menu and sidebar toggle functionality

document.addEventListener('DOMContentLoaded', () => {
  // Profile menu toggle
  const profileToggle = document.querySelector('[toggle-profile]')

  if (profileToggle) {
    const targetClass = profileToggle.getAttribute('toggle-profile')
    const targetElement = document.querySelector(`.${targetClass}`)

    if (targetElement) {
      profileToggle.addEventListener('click', (e) => {
        e.stopPropagation()
        targetElement.classList.toggle('header-nav__item--active')
      })

      document.body.addEventListener('click', () => {
        targetElement.classList.remove('header-nav__item--active')
      })
    }
  }

  // Sidebar toggle
  const sidebarToggle = document.querySelector('[toggle-sidebar]')

  if (sidebarToggle) {
    const targetClass = sidebarToggle.getAttribute('toggle-sidebar')
    const sidebar = document.querySelector(`.${targetClass}`)
    const pageContent = document.querySelector('.page-content')

    if (sidebar) {
      sidebarToggle.addEventListener('click', (e) => {
        e.stopPropagation()
        sidebar.classList.toggle('sidebar--opened')
        if (pageContent) {
          pageContent.classList.toggle('page-content--opened-sidebar')
        }
      })
    }
  }
})
